import { render, staticRenderFns } from "./createbill.vue?vue&type=template&id=58923763&scoped=true&"
import script from "./createbill.vue?vue&type=script&lang=js&"
export * from "./createbill.vue?vue&type=script&lang=js&"
import style0 from "./createbill.vue?vue&type=style&index=0&id=58923763&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58923763",
  null
  
)

export default component.exports